export default {
	cardStates: [
		{ label: 'All', value: '' },
		{ label: 'To Learn', value: 'getToLearnCards' },
		{ label: 'Known', value: 'getKnownCards' },
		{ label: 'Learned', value: 'getLearnedCards' }
	]
}
